export default "__VITE_ASSET__DeDhfqME__"